<div class="renewals-main-container">
  <div class="workflow-container" (click)="closeAllDropdowns()">
    <div class="header-row" (click)="$event.stopPropagation()">
      <!-- FILTER ROW -->
      <app-common-filterbuilder-staff-janus
        [placeholder]="'Search Renewals'"
        (search)="onSearch($event)"
        (attributeSelect)="onAttribute($event)"
        [attributeOptions]="applicationAttributes"
        [myWorkOptions]="myWorkOptions"
        (filterChanged)="onFilterChanged($event)"
        [useMuiLayout]="true"
        [local_storage_key]="FILTER_CACHE_KEY"
        [externalFilterInputs]="filterInputs"
        (externalFilterInputsChange)="onExternalFiltersChanged($event)"
        [customTemplate]="exportsButtonTemplate"
        [id]="'renewals-table'"
      >
      </app-common-filterbuilder-staff-janus>

      <!-- Added by Vipul on 10/03/2026 -->
      <ng-template #exportsButtonTemplate>
        <app-scheduled-exports-janus
          [componentId]="id"
          [title]="title"
          [params]="applicationAttributes"
          [currentFilters]="filterOptions"
          [currentColumnOptions]="columnOptions"
          [separateDropdown]="false"
          (exportExcel)="exportExcel()"
          (exportCsv)="exportCsv()"
        ></app-scheduled-exports-janus>
      </ng-template>
      <!-- End by Vipul on 10/03/2026 -->
    </div>

    <div class="tabs-row renewal-header-tab">
      <div class="tab-button active">
        Renewals
        <span class="underline"></span>
      </div>
    </div>

    <div class="data-table-main-container">
      <wm-renewals-janus-table
        [data]="renewals"
        [serverSidePagination]="true"
        [currentPage]="currentPage"
        [totalPages]="totalPages"
        [totalRecords]="totalRecords"
        [pageSize]="pageSize"
        [pageSizeStorageKey]="'renewals-janus'"
        [isLoading]="isLoading"
        (pageChange)="onPageChange($event)"
        (rowsPerPageChange)="onRowsPerPageChange($event)"
        (columnsChange)="receiveColumns($event)"
        (displayedColumnsChange)="onRenewalDisplayedColumnsChange($event)"
        (sortChanged)="onSortChanged($event)"
        [sortField]="sortField"
        [sortDescending]="sortDescending"
      >
      </wm-renewals-janus-table>
    </div>
  </div>

  <router-outlet name="overlay"></router-outlet>
</div>
